import { render, staticRenderFns } from "./searchAssociation.vue?vue&type=template&id=61f704d0&scoped=true"
import script from "./searchAssociation.vue?vue&type=script&lang=js"
export * from "./searchAssociation.vue?vue&type=script&lang=js"
import style0 from "./searchAssociation.vue?vue&type=style&index=0&id=61f704d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f704d0",
  null
  
)

export default component.exports